interface BuildBookingEventPropsParams {
  isRescheduling: boolean;
  isCoachMatchingServiceBooking: boolean;
  coachId?: number | null;
  serviceName?: string;
  rescheduleSessionId?: number | null;
}

/**
 * Builds the actor-identity properties shared by every booking/reschedule
 * analytics event, keeping the `isRescheduling → coach-matching → coach`
 * branching in one place instead of duplicated across each `trackBookingEvent`
 * call site. Callers spread the result and add event-specific properties.
 *
 * - Reschedule → `{ coach_id, original_session_id }`
 * - Coach Matching Service → `{ service_name }` (no individual coach yet)
 * - Standard coach session → `{ coach_id }`
 */
export function buildBookingEventProps({
  isRescheduling,
  isCoachMatchingServiceBooking,
  coachId,
  serviceName,
  rescheduleSessionId,
}: BuildBookingEventPropsParams) {
  if (isRescheduling) {
    return {
      coach_id: coachId ?? null,
      original_session_id: rescheduleSessionId ?? null,
    };
  }

  if (isCoachMatchingServiceBooking) {
    return { service_name: serviceName };
  }

  return { coach_id: coachId ?? null };
}
